import { process } from "am-tax-fe-core";

import { components } from "../generated/generated-api";
import { client } from "../entities/entityApi";

//#region Dto definition
export type FileResponse = components["schemas"]["FileResponse"];

export const getFilesAndFolders = async (): Promise<FileResponse[]> => process(client().GET("/api/sharepoint/items"));
